import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from '../../lib/axios';
import {
  Box, Card, CardContent, Typography, Grid, List, ListItem, ListItemAvatar, ListItemText, Divider, Chip, Avatar, TableContainer, Table,
  TableHead, TableBody, TableRow, TableCell, ToggleButtonGroup, ToggleButton, CircularProgress, useTheme,
  Tooltip, IconButton, useMediaQuery, Button, Paper, styled
} from '@mui/material';
import {
  Receipt as ReceiptIcon,
  CalendarToday as CalendarTodayIcon,
  Check as CheckIcon,
  Warning as WarningIcon,
  ContentCopy as ContentCopyIcon,
  Print as PrintIcon,
  Schedule as ScheduleIcon,
  CalendarViewMonth as CalendarViewMonthIcon,
  MonetizationOn as MonetizationOnIcon,
  Paid as PaidIcon,
  PendingActions as PendingActionsIcon,
  Pending as PendingIcon,
  Description as DescriptionIcon,
  Payment as PaymentIcon,
  CalendarToday as DateIcon,
  Person as PersonIcon,
  Phone as PhoneIcon,
  AttachMoney as MoneyIcon,
  CheckCircle as SuccessIcon,
  Error as ErrorIcon
} from '@mui/icons-material';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import HistoryIcon from '@mui/icons-material/History';
import axios from 'axios';
import AuthHeader from '../../Auth';
import axiosInstanceForPG from '../../lib/axiosFormPG';
import { toast, ToastContainer } from 'react-toastify';
import { useReactToPrint } from 'react-to-print';
import BookingReportchekin from '../../atoms/ReportFolder/BookingReportchekin';
import BillingDetailsModal from '../Ragistration/BConfirmation/ACCGenerateDetailsModal';
import dayjs from "dayjs";
import { Select, MenuItem, FormControl } from '@mui/material';

const AccountsTab = ({ bookingData, onCloseAccountDialog }) => {
  const [adviceData, setAdviceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeView, setActiveView] = useState('advice');
  const [emailResponse, setEmailResponse] = useState(null);
  const [openBillingModal, setOpenBillingModal] = useState(false);
  const [PlanDataState, setPlanDataState] = useState(null);
  const [billingDetails, setBillingDetails] = useState(null);
  const [PayAdvice, setPayAdvice] = useState(null);
  const [PayGenerate, setPayGenerate] = useState(null);
  const [PendingDetails, setPendingDetails] = useState(null);
  const [OpenLoader, setOpenLoader] = useState(false);
  const [SummaryReport, setSummaryReport] = useState(null);
  const [ReceiptSummary, setReceiptSummary] = useState(null);
  const [pendingAdviceData, setPendingAdviceData] = useState([]);
  const theme = useTheme();
  const contentRef = useRef();
  const baseUrl = window.location.origin;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [bookingHistory, setBookingHistory] = useState([]);
  const [selectedBookId, setSelectedBookId] = useState(bookingData?.BookId || null);
  const [selectedBookNo, setSelectedBookNo] = useState('');
  const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: '16px',
    boxShadow: theme.shadows[10],
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-5px)'
    },
    background: theme.palette.background.paper
  }));
  const handlePrint = useReactToPrint({
    contentRef
  });
  const fetchPendingAdviceData = async (bookId) => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        PytAdvDt: "2025-02-26",
        Flag: "UnBilledAdvPyt",
        BookId: bookId
      });

      if (response.data.Status === 0 || response.data.Status === 1) {
        setPendingAdviceData(response.data.Data || []);
      }
    } catch (error) {
      setPendingAdviceData([]);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (bookingData?.BookId && activeView === 'advice') {
      fetchPendingAdviceData(bookingData.BookId);
    }
  }, [bookingData?.BookId, activeView]);
  const fetchPaymentData = async (flag) => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        PytAdvDt: "2025-02-26",
        "Flag": flag,
        "BookId": bookingData.BookId
      });

      if (response.data.Status === 0 || response.data.Status === 1) {
        setAdviceData(response.data.Data || []);
      }
    } catch (error) {
      setAdviceData([]);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchSummaryReport = async (Id) => {
    try {
      setOpenLoader(true);
      const currentDate = dayjs().format('YYYY-MM-DD');
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        PytAdvDt: currentDate,
        Flag: "GenAccSum",
        BookId: Id
      });

      if (response.data.Status === 0) {
        setSummaryReport(response.data.Data);
        setOpenBillingModal(true);
      }
    } catch (error) {
    } finally {
      setOpenLoader(false);
    }
  };

  const fetchReceiptReport = async (Id) => {
    try {
      setOpenLoader(true);
      const currentDate = dayjs().format('YYYY-MM-DD');
      const response = await axiosInstance.post('BookingReports/GetBookingReportsDetail', {
        BookDtFrom: currentDate,
        BookUpToDt: currentDate,
        PropId: "88",
        Flag: "PyAdvWiseRecVchr",
        Id: Id
      });
      if (response.data.Status === 0) {
        setReceiptSummary(response.data.Data);
        setOpenBillingModal(true);
      }
    } catch (error) {
      toast.error('Error While fetching the receipt summary.');
    } finally {
      setOpenLoader(false);
    }
  };
  const fetchTransactionHistory = async () => {
    try {
      setOpenLoader(true);
      const response = await axiosInstance.post('TrnBooking/GetTrnBookingDashBoard', {
        "start": 1,
        "PageSize": 1,
        "SearchText": "",
        "Flag": "",
        "MobileNo": bookingData?.MobileNo || "",
        "BookNo": "",
        "PropId": 1
      });

      if (response.data.Status === 0 && response.data.Data?.length > 0) {
        setBookingHistory(response.data.Data);

        const currentBooking = response.data.Data.find(b => b.BookId === bookingData?.BookId);
        if (currentBooking) {
          setSelectedBookNo(currentBooking.BookNo);
          setSelectedBookId(currentBooking.BookId);
        }
      }
    } catch (error) {
      toast.error('Error fetching booking history');
    } finally {
      setOpenLoader(false);
    }
  };
  const fetchPaymentAdviceByBookId = async (bookId) => {
    try {
      setIsLoading(true);
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        PytAdvDt: "2025-02-26",
        Flag: "GenPytAdv",
        BookId: bookId
      });

      if (response.data.Status === 0 || response.data.Status === 1) {
        setAdviceData(response.data.Data || []);
      }
    } catch (error) {
      setAdviceData([]);
      toast.error('Error fetching payment advice');
    } finally {
      setIsLoading(false);
    }
  };
  const handleBookingChange = (event) => {
    const selectedBookingId = parseInt(event.target.value);
    const selectedBooking = bookingHistory.find(b => b.BookId === selectedBookingId);

    if (selectedBooking) {
      setSelectedBookId(selectedBookingId);
      setSelectedBookNo(selectedBooking.BookNo);
      fetchPaymentAdviceByBookId(selectedBookingId);
      fetchPendingAdviceData(selectedBookingId);
    }
  };
  useEffect(() => {
    if (bookingData?.MobileNo) {
      fetchTransactionHistory();
    }
  }, [bookingData?.MobileNo]);
  const handleViewChange = (newView) => {
    if (!newView) return;
    if (newView === 'statement' && onCloseAccountDialog) {
      onCloseAccountDialog();
    }
    setActiveView(newView);
    if (newView === 'statement') {
      handleBillingDetails();
    } else if (newView === 'advice') {
      fetchPaymentData('GenPytAdv');
    } else if (newView === 'installments') {
      fetchPaymentData('BookingWise');
    }
    // if (newView === 'advice') {
    //   fetchPaymentData('GenPytAdv');
    // } else if (newView === 'installments') {
    //   fetchPaymentData('BookingWise');
    // }
  };

  useEffect(() => {
    if (bookingData?.BookId) {
      fetchPaymentData('GenPytAdv');
    }
  }, [bookingData?.BookId]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '? 0';
    return amount.toLocaleString('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).replace('?', '? ');
  };

  const getPaymentType = (type) => {
    switch (type) {
      case 'D': return 'Deposit';
      case 'R': return 'Rent';
      case 'O': return 'Other';
      case 'T': return 'Top-up';
      default: return type;
    }
  };
  const handleSendPaymentLink = async (item) => {
    console.log('item', item)
    try {
      setIsLoading(true);
      const userId = parseInt(localStorage.getItem('ResidentId'));

      const paymentDetails = {

        "pagenumber": 1,
        "PageSize": 1,
        "SearchText": item?.PytAdvId?.toString() || "",
        "PropId": bookingData?.PropId?.toString() || "",
        "SearchFrom": "2026-01-01",
        "SearchTo": "2026-12-31",
        "Flag": "Url"

      }

      const response = await axiosInstanceForPG.post(
        `PaymentGatewayLog/GetPaymentRequestLogDashBoard`,
        paymentDetails,
      );
      const paymentUrl = response?.data?.Data?.[0]?.longUrl;

      if (paymentUrl) {
        window.open(paymentUrl, '_blank');
      } else {
        toast.error("Payment URL not found");
      }
    } catch (error) {
      toast.error("Failed to send payment link");
    }
    finally {
      setIsLoading(false);
    }
  };
  const extractPaymentLink = (emailBody) => {
    const linkRegex = /Payment Link : (https?:\/\/[^\s<]+)/i;
    const match = emailBody?.match(linkRegex);
    return match ? match[1] : null;
  };

  const BookingDetail = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <Card>
            <CardContent>
              <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <CalendarTodayIcon color="primary" sx={{ mr: 1 }} />
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    Booking Details
                  </Typography>
                </Box>
                <Button
                  variant="contained"
                  startIcon={<PrintIcon />}
                  onClick={handlePrint}
                >
                  Print
                </Button>
              </Box>
              {<BookingReportchekin contentRef={contentRef} DataObj={bookingData} />}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  };

  const InstallmentPlanView = () => {
    if (!adviceData.length) {
      return (
        <Typography variant="body2" color="text.secondary" sx={{ p: 4, textAlign: 'center' }}>
          No installment details found
        </Typography>
      );
    }

    return isMobile ? (
      <MobileInstallmentView items={adviceData} />
    ) : (
      <DesktopInstallmentView items={adviceData} />
    );
  };

  const MobileInstallmentView = ({ items }) => (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <DescriptionIcon color="primary" />
        <Typography variant="h6" sx={{ fontWeight: 'bold',fontSize:'1rem' }}>
          Payment Advice
        </Typography>
        {bookingHistory.length > 0 && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 500 }}>
              Select Booking:
            </Typography>
            <FormControl size="small" >
              <Select
                value={selectedBookId || ''}
                onChange={handleBookingChange}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) return <em>Select Booking</em>;
                  const booking = bookingHistory.find(b => b.BookId === selected);
                  return booking?.BookNo || '';
                }}
                sx={{
                  '& .MuiSelect-select': {
                    py: 0.3,
                    px: 1,
                    fontSize: '0.875rem'
                  }
                }}
              >
                {bookingHistory.map((booking) => (
                  <MenuItem key={booking.BookId} value={booking.BookId} >
                    <Box>
                      <Typography variant="body2">
                        {booking.BookNo}
                      </Typography>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
      </Box>

      <List dense>
        {items.map((item) => {
          const amount = item.MonthlyNetAmt || item.Amount || 0;
          const paid = item.RcdAmt || 0;
          const balance = amount - paid;
          const dueDate = new Date(item.DueDt || item.PytAdvDt);
          const today = new Date();
          const isPaid = paid > 0;
          const isOverdue = !isPaid && dueDate < today;
          const diffDays = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));

          return (
            <Card
              key={item.PytAdvId || item.MonthId}
              variant="outlined"
              sx={{
                mb: 1.5,
                borderRadius: 2,
                px: 1,
                py: 1,
                boxShadow: 1,
                backgroundColor: '#f0f8ff',
                // backgroundColor: theme.palette.background.paper,
              }}
            >
      
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  mb: 1,
                }}
              >
                {/* Left: Icon + Advice No */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Avatar
                    sx={{
                      width: 28,
                      height: 28,
                      bgcolor: isPaid
                        ? theme.palette.success.light
                        : isOverdue
                          ? theme.palette.error.light
                          : theme.palette.warning.light,
                      fontSize: '1rem',
                    }}
                  >
                    {isPaid ? (
                      <CheckIcon fontSize="small" />
                    ) : isOverdue ? (
                      <WarningIcon fontSize="small" />
                    ) : (
                      <PendingIcon fontSize="small" />
                    )}
                  </Avatar>
                  <Typography variant="subtitle2" fontWeight={600}>
                    {item.PytAdvNo || 'Installment'}
                  </Typography>
                </Box>

                <Chip
                  label={
                    isPaid
                      ? 'Paid'
                      : isOverdue
                        ? `${Math.abs(diffDays)}d Overdue`
                        : `Due in ${diffDays}d`
                  }
                  size="small"
                  color={
                    isPaid
                      ? 'success'
                      : isOverdue
                        ? 'error'
                        : 'warning'
                  }
                  variant="outlined"
                />
              </Box>

              {/* Grid Details */}
              <Grid container spacing={0.5}>
                {/* Row 1: Advice Date & Due Date */}
                <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                  <Typography variant="caption" display="block">
                    <strong>Advice Date:</strong> {formatDate(item.PytAdvDt)}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                  <Typography variant="caption" display="block">
                    <strong>Due Date:</strong> {formatDate(item.DueDt || item.PytAdvDt)}
                  </Typography>
                </Grid>

                {/* Row 2: Amount & Paid */}
                <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                  <Typography variant="caption" display="block">
                    <strong>Amount:</strong> {formatCurrency(amount)}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                  <Typography variant="caption" display="block">
                    <strong>Paid:</strong> {formatCurrency(paid)}
                  </Typography>
                </Grid>

          
                <Grid item xs={12} sx={{ paddingTop: '0 !important' }}>
                  <Typography variant="caption" display="block">
                    <strong>Balance:</strong> {formatCurrency(balance)}
                  </Typography>
                </Grid>

              
                {item.Remark && (
                  <Grid item xs={12} sx={{ paddingTop: '0 !important' }}>
                    <Typography variant="caption" display="block">
                      <strong>Remarks:</strong> {item.Remark}
                    </Typography>
                  </Grid>
                )}
              </Grid>


              {isOverdue && (
                <Box sx={{ mt: 1 }}>
                  <Button
                    variant="contained"
                    color="success"
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderRadius: '6px',
                      fontSize: '0.75rem',
                      px: 1.5,
                      py: 0.4,
                      boxShadow: 'none',
                      '&:hover': {
                        boxShadow: 'none',
                        backgroundColor: theme.palette.success.dark,
                      },
                    }}
                    onClick={() => handleSendPaymentLink(item)}
                  >
                    Pay Now
                  </Button>
                </Box>
              )}
            </Card>
          );
        })}
      </List>

      {pendingAdviceData && pendingAdviceData.length > 0 && (
        <Box mb={0.5}>
          <Typography
            variant="h6"
            gutterBottom
            color="primary"
            sx={{
              borderBottom: '2px solid #635bff',
              paddingBottom: 0,
              fontSize: '1rem',
              fontWeight: 'bold',
            }}
          >
            Pending Advice
          </Typography>

          {isMobile ? (
            <Box>
              {pendingAdviceData.map((item, index) => (
                <Card
                  key={index}
                  variant="outlined"
                  sx={{
                    mb: 1.5,
                    p: 1.5,
                    borderRadius: 2,
                    backgroundColor: '#e0d1d1ff',
                    boxShadow: 'sm',
                  }}
                >
                  <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                    Booking No: {item?.BookNo}
                  </Typography>
                  <Grid container spacing={0.5}>
                    <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                      <Typography variant="caption" display="block">
                        <strong>Book Date:</strong> {formatDate(item?.BookDt)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '0 !important' }} >
                      <Typography variant="caption" display="block">
                        <strong>Due Date:</strong> {formatDate(item?.DueDt)}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                      <Typography variant="caption" display="block">
                        <strong>Unit:</strong> {item?.RoombedName}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                      <Typography variant="caption" display="block">
                        <strong>Due Days:</strong> {item?.DueDays}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                      <Typography variant="caption" display="block">
                        <strong>Amount:</strong> ? {item?.Amount}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{ paddingTop: '0 !important' }}>
                      <Typography variant="caption" display="block">
                        <strong>Balance:</strong> ? {item?.BalAmount}
                      </Typography>
                    </Grid>
                    {item?.Remark && (
                      <Grid item xs={12} sx={{ paddingTop: '0 !important' }}>
                        <Typography variant="caption" display="block">
                          <strong>Remark:</strong> {item?.Remark}
                        </Typography>
                      </Grid>
                    )}
                  </Grid>
                </Card>
              ))}
            </Box>
          ) : (
            //  Desktop View: Table
            <TableContainer component={Paper} sx={{ maxHeight: 340 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {['Booking No', 'Book Date', 'Unit', 'Adv Amt', 'Bal Amt', 'Due Days', 'Due Date', 'Remark'].map(
                      (head) => (
                        <TableCell
                          key={head}
                          sx={{
                            fontWeight: 'bold',
                            backgroundColor: '#f5f5f5',
                            padding: '6px 16px',
                            height: '32px',
                          }}
                        >
                          {head}
                        </TableCell>
                      )
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pendingAdviceData.map((item, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                        height: '16px',
                      }}
                    >
                      <TableCell sx={{ padding: '2px 16px' }}>{item?.BookNo}</TableCell>
                      <TableCell sx={{ padding: '2px 16px' }}>{formatDate(item?.BookDt)}</TableCell>
                      <TableCell sx={{ padding: '2px 16px' }}>{item?.RoombedName}</TableCell>
                      <TableCell sx={{ padding: '2px 16px' }}>{item?.Amount}</TableCell>
                      <TableCell sx={{ padding: '2px 16px' }}>{item?.BalAmount}</TableCell>
                      <TableCell sx={{ padding: '2px 16px' }}>{item?.DueDays}</TableCell>
                      <TableCell sx={{ padding: '2px 16px' }}>{formatDate(item?.DueDt)}</TableCell>
                      <TableCell sx={{ padding: '2px 16px' }}>{item?.Remark}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      )}
    </Box>
  );

  const DesktopInstallmentView = ({ items }) => (
    <TableContainer>
      <Box sx={{ display: 'flex', alignItems: 'center',justifyContent: 'space-between', mb: 1 }}>
      
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
            <DescriptionIcon color="primary"/>Payment Advice
        </Typography>
        {bookingHistory.length > 0 && (
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 ,color:'green',fontSize:'0.95rem'}}>
              Select Booking:
            </Typography>
            <FormControl size="small" >
              <Select
                value={selectedBookId || ''}
                onChange={handleBookingChange}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) return <em>Select Booking</em>;
                  const booking = bookingHistory.find(b => b.BookId === selected);
                  return booking?.BookNo || '';
                }}
                 sx={{
                  '& .MuiSelect-select': {
                    py: 0.4,
                    px: 1,
                    fontSize: '0.875rem'
                  }
                }}
              >
                {bookingHistory.map((booking) => (
                  <MenuItem key={booking.BookId} value={booking.BookId}>
                    <Box>
                      <Typography variant="body2">
                        {booking.BookNo}
                      </Typography>

                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}
        {emailResponse && (
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mt: 0,
            marginLeft: '16px',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            backgroundColor: 'background.paper'
          }}>
            <Typography
              variant="body2"
              component="a"
              href={emailResponse}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                flexGrow: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: 'primary.main',
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              {emailResponse}
            </Typography>
            <Tooltip title="Copy to clipboard">
              <IconButton
                size="small"
                onClick={() => {
                  navigator.clipboard.writeText(emailResponse);
                  toast.success("Payment link copied!");
                }}
              >
                <ContentCopyIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </Box>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Advice No</TableCell>
            <TableCell>Advice Date</TableCell>
            <TableCell>Due Date</TableCell>
            <TableCell align="right">Amount</TableCell>
            <TableCell align="right">Paid</TableCell>
            <TableCell align="right">Balance</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Due Days</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Remarks</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => {
            const amount = item.MonthlyNetAmt || item.Amount || 0;
            const paid = item.RcdAmt || 0;
            const balance = amount - paid;
            const dueDate = new Date(item.DueDt || item.PytAdvDt);
            const today = new Date();
            const isPaid = paid > 0;
            const isOverdue = !isPaid && dueDate < today;

            return (
              <TableRow key={item.PytAdvId}>
                <TableCell>{item.PytAdvNo}</TableCell>
                <TableCell>{formatDate(item.PytAdvDt)}</TableCell>
                <TableCell>{formatDate(item.DueDt)}</TableCell>
                <TableCell align="right">{formatCurrency(amount)}</TableCell>
                <TableCell align="right">{isPaid ? formatCurrency(paid) : '-'}</TableCell>
                <TableCell align="right">{balance > 0 ? formatCurrency(balance) : '-'}</TableCell>
                <TableCell>{getPaymentType(item.PytAdvFor)}</TableCell>
                <TableCell>{item.DueDays} Days</TableCell>
                <TableCell>
                  {isPaid ? (
                    <Chip label="Paid" color="success" size="small" />
                  ) : isOverdue ? (
                    <Chip label="Overdue" color="error" size="small" />
                  ) : (
                    <Chip label="Pending" color="warning" size="small" />
                  )}
                  {isOverdue && (
                    <Button
                      variant="contained"
                      color="success"
                      size="small"

                      onClick={() => handleSendPaymentLink(item)}
                      sx={{
                        padding: "2px 0px",
                        ml: '2px',
                        textTransform: 'none',
                        borderRadius: '8px',
                        boxShadow: 'none',
                        '&:hover': {
                          boxShadow: 'none',
                          backgroundColor: theme.palette.success.dark
                        }
                      }}
                    >
                      Pay Now
                    </Button>
                  )}
                </TableCell>
                <TableCell>{item.Remark || '-'}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {pendingAdviceData && pendingAdviceData.length > 0 && (
        <Box mb={0.5}>
          <Typography variant="h6" gutterBottom color="primary" sx={{ borderBottom: '2px solid #635bff', paddingBottom: 0, fontSize: '1rem', fontWeight: 'bold' }}>
            Pending Advice
          </Typography>
          <TableContainer component={Paper} sx={{ maxHeight: 340 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', padding: '6px 16px', height: '32px' }}>Booking No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', padding: '6px 16px', height: '32px' }}>Book Date</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', padding: '6px 16px', height: '32px' }}>Unit</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', padding: '6px 16px', height: '32px' }}>Adv Amt</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', padding: '6px 16px', height: '32px' }}>Bal Amt</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', padding: '6px 16px', height: '32px' }}>Due Days</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', padding: '6px 16px', height: '32px' }}>Due Date</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5', padding: '6px 16px', height: '32px' }}>Remark</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {pendingAdviceData?.map((PendingDetails, index) => (
                  <TableRow key={index} sx={{
                    '&:nth-of-type(odd)': { backgroundColor: '#fafafa' },
                    height: '16px'
                  }}>
                    <TableCell sx={{ padding: '2px 16px' }}>{PendingDetails?.BookNo}</TableCell>
                    <TableCell sx={{ padding: '2px 16px' }}>{formatDate(PendingDetails?.BookDt)}</TableCell>
                    <TableCell sx={{ padding: '2px 16px' }}>{PendingDetails?.RoombedName}</TableCell>
                    <TableCell sx={{ padding: '2px 16px' }}>{PendingDetails?.Amount}</TableCell>
                    <TableCell sx={{ padding: '2px 16px' }}>{PendingDetails?.BalAmount}</TableCell>
                    <TableCell sx={{ padding: '2px 16px' }}>{PendingDetails?.DueDays}</TableCell>
                    <TableCell sx={{ padding: '2px 16px' }}>{formatDate(PendingDetails?.DueDt)}</TableCell>
                    <TableCell sx={{ padding: '2px 16px' }}>{PendingDetails?.Remark}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </TableContainer>
  );


  const PaymentView = () => {
    const [payment, setPayment] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchPaymentData = async () => {
      try {
        setLoading(true);
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}TrnRctVchr/GetTrnRctVchrDashBoard`,
          {
            start: 1,
            PageSize: 1,
            SearchText: bookingData?.ResidentId || ""
          },
          AuthHeader()
        );
        setPayment(response.data.Data || []);
      } catch (err) {
        setError(err.message || "Failed to fetch payment data");
      } finally {
        setLoading(false);
      }
    };

    useEffect(() => {
      if (bookingData?.ResidentId) {
        fetchPaymentData();
      }
    }, [bookingData?.ResidentId]);

    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      return new Date(dateString).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    };

    const formatCurrency = (amount) => {
      if (amount === null || amount === undefined) return '?0';
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    };

    if (loading) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
          <CircularProgress size={60} />
        </Box>
      );
    }

    if (error) {
      return (
        <Paper elevation={3} sx={{ p: 3, textAlign: 'center', bgcolor: 'error.light' }}>
          <ErrorIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
          <Typography variant="h6" color="error">
            Error Loading Payment Data
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            {error}
          </Typography>
        </Paper>
      );
    }

    return (
      <>
        <CardContent sx={{ p: '0 !important' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <ReceiptIcon color="primary" sx={{ fontSize: 30, mr: 2 }} />
            <Typography variant="h6" fontWeight="bold">
              Payment Transactions
            </Typography>
          </Box>

          {payment.length > 0 ? (
            isMobile ? (
              // Mobile View (Cards)
              <Box>
                {payment.map((transaction) => (
                  <Card key={transaction.RecId} sx={{ mb: 2, borderRadius: 2, backgroundColor: '#f0f8ff' }}>
                    <CardContent sx={{ p: '8px !important' }}>
                      {/* Top Row: Avatar + RecNo + Status Chip */}
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <Avatar sx={{ bgcolor: 'primary.main', width: 36, height: 36, mr: 1 }}>
                            <Typography variant="caption" color="white">
                              {transaction.RecNo.slice(-2)}
                            </Typography>
                          </Avatar>
                          <Typography fontWeight="bold">{transaction.RecNo}</Typography>
                        </Box>

                        <Chip
                          label={transaction.Status === '1' ? 'Completed' : 'Pending'}
                          color={transaction.Status === '1' ? 'success' : 'warning'}
                          size="small"
                          icon={transaction.Status === '1' ? <CheckIcon /> : <PendingIcon />}
                        />
                      </Box>

                      {/* Row: Date (start) + Txn Ref (near end) */}
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                        <Typography variant="body2"><strong>Date:</strong> {formatDate(transaction.RecDt)}</Typography>
                        <Typography variant="body2" sx={{ ml: 'auto', pr: 1 }}>
                          <strong>Txn Ref:</strong> {transaction.ChequeNo}
                        </Typography>
                      </Box>

                      {/* Row: Amount (start) + Type (near end) */}
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                        <Typography variant="body2">
                          <strong>Amount:</strong>{' '}
                          <Box component="span" color="success.main" fontWeight="bold">
                            {formatCurrency(transaction.RcdAmt)}
                          </Box>
                        </Typography>
                        <Typography variant="body2" sx={{ ml: 'auto', pr: 1 }}>
                          <strong>Type:</strong> {transaction.Pyttype}
                        </Typography>
                      </Box>

                      {/* Optional Remark */}
                      {transaction.Remark && (
                        <Typography variant="body2"><strong>Remark:</strong> {transaction.Remark}</Typography>
                      )}
                    </CardContent>
                  </Card>
                ))}
              </Box>
            ) : (
              // Desktop View (Table)
              <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
                <Table sx={{ minWidth: 650 }}>
                  <TableHead sx={{ bgcolor: theme.palette.primary.light }}>
                    <TableRow>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 1, px: 1.5 }}>Receipt No</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 1, px: 1.5 }}>Date</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 1, px: 1.5 }}>Transaction Ref</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 1, px: 1.5 }}>Amount</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 1, px: 1.5 }}>Type</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 1, px: 1.5 }}>Status</TableCell>
                      <TableCell sx={{ color: 'white', fontWeight: 'bold', py: 1, px: 1.5 }}>Remark</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {payment.map((transaction) => (
                      <TableRow
                        key={transaction.RecId}
                        hover
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                          '&:hover': { bgcolor: 'action.hover' },
                        }}
                      >
                        <TableCell sx={{ py: 0.5, px: 1.5 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar sx={{ bgcolor: 'primary.main', width: 32, height: 32, mr: 1 }}>
                              <Typography variant="caption" sx={{ color: 'white' }}>
                                {transaction.RecNo.slice(-2)}
                              </Typography>
                            </Avatar>
                            <Typography fontWeight="medium">{transaction.RecNo}</Typography>
                          </Box>
                        </TableCell>
                        <TableCell sx={{ py: 0.5, px: 1.5 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                            <DateIcon color="action" sx={{ mr: 1 }} />
                            {formatDate(transaction.RecDt)}
                          </Box>
                        </TableCell>
                        <TableCell sx={{ py: 0.5, px: 1.5 }}>{transaction.ChequeNo}</TableCell>
                        <TableCell sx={{ py: 0.5, px: 1.5 }}>
                          <Typography fontWeight="bold" color="success.main">
                            {formatCurrency(transaction.RcdAmt)}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ py: 0.5, px: 1.5 }}>
                          <Chip label={transaction.Pyttype} color="primary" variant="outlined" size="small" />
                        </TableCell>
                        <TableCell sx={{ py: 0.5, px: 1.5 }}>
                          <Chip
                            label={transaction.Status === '1' ? 'Completed' : 'Pending'}
                            color={transaction.Status === '1' ? 'success' : 'warning'}
                            size="small"
                            icon={transaction.Status === '1' ? <CheckIcon /> : <PendingIcon />}
                          />
                        </TableCell>
                        <TableCell sx={{ py: 0.5, px: 1.5 }}>{transaction.Remark || 'N/A'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )
          ) : (
            <Box textAlign="center" py={4}>
              <ReceiptIcon sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }} />
              <Typography variant="h6" color="text.secondary">
                No payment records found
              </Typography>
            </Box>
          )}

          {payment.length > 0 && (
            <Grid container columnSpacing={2} rowSpacing={1} sx={{ mt: 2 }}>
              {/* Total Transactions */}
              <Grid item xs={12} md={4}>
                <Card sx={{ bgcolor: 'primary.light', color: 'white', borderRadius: '8px' }}>
                  <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, '&:last-child': { pb: 2 } }}>
                    <ReceiptLongIcon sx={{ fontSize: 40 }} />
                    <Box>
                      <Typography variant="subtitle2">Total Transactions</Typography>
                      <Typography variant="h5" fontWeight="bold">
                        {payment.length}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Total Amount */}
              <Grid item xs={12} md={4}>
                <Card sx={{ bgcolor: 'success.light', color: 'white', borderRadius: '8px' }}>
                  <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, '&:last-child': { pb: 2 } }}>
                    <CurrencyRupeeIcon sx={{ fontSize: 40 }} />
                    <Box>
                      <Typography variant="subtitle2">Total Amount</Typography>
                      <Typography variant="h5" fontWeight="bold">
                        {formatCurrency(payment.reduce((sum, t) => sum + t.RcdAmt, 0))}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Last Transaction */}
              <Grid item xs={12} md={4}>
                <Card sx={{ bgcolor: 'warning.light', color: 'white', borderRadius: '8px' }}>
                  <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, '&:last-child': { pb: 2 } }}>
                    <HistoryIcon sx={{ fontSize: 40 }} />
                    <Box>
                      <Typography variant="subtitle2">Last Transaction</Typography>
                      <Typography variant="h7" fontWeight="bold">
                        {payment[0].RecNo} - {formatDate(payment[0].RecDt)}
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </>
    );
  };

  const StatementView = () => {
    const [statementData, setStatementData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [totalSummary, setTotalSummary] = useState({
      totalStdRent: 0,
      totalCouponDisc: 0,
      totalNetRent: 0,
      totalFmDisc: 0,
      totalEffRent: 0,
      totalPyadAmt: 0,
      totalBalPyadAmt: 0
    });

    useEffect(() => {
      const fetchStatementData = async () => {
        try {
          setIsLoading(true);
          setError(null);

          const response = await axiosInstance.post(
            'BedCalendar/GetTrnBookingDtlwise',
            {
              BookId: bookingData.BookId,
            }
          );

          if (response.data.Status === 0) {
            setStatementData(response.data.Data);

            const summary = response.data.Data.reduce((acc, item) => ({
              totalStdRent: acc.totalStdRent + (item.StdRent || 0),
              totalCouponDisc: acc.totalCouponDisc + (item.CouponDisc || 0),
              totalNetRent: acc.totalNetRent + (item.NetRent || 0),
              totalFmDisc: acc.totalFmDisc + (item.FmDisc || 0),
              totalEffRent: acc.totalEffRent + (item.EffRent || 0),
              totalPyadAmt: acc.totalPyadAmt + (item.PyadAmt || 0),
              totalBalPyadAmt: acc.totalBalPyadAmt + (item.BalPyadAmt || 0)
            }), {
              totalStdRent: 0,
              totalCouponDisc: 0,
              totalNetRent: 0,
              totalFmDisc: 0,
              totalEffRent: 0,
              totalPyadAmt: 0,
              totalBalPyadAmt: 0
            });

            setTotalSummary(summary);
          } else {
            setError(response.data.Message || 'Failed to fetch statement data');
          }
        } catch (err) {
          console.error('Error fetching statement data:', err);
          setError('Failed to fetch statement data. Please try again.');
        } finally {
          setIsLoading(false);
        }
      };

      if (bookingData?.BookId) {
        fetchStatementData();
      }
    }, [bookingData?.BookId]);

    const getPaymentStatus = (item) => {
      if (item.PyadAmt > 0 && item.BalPyadAmt === 0) {
        return { status: 'Paid', color: 'success' };
      } else if (item.PyadAmt > 0 && item.BalPyadAmt > 0) {
        return { status: 'Partial', color: 'warning' };
      } else {
        return { status: 'Pending', color: 'error' };
      }
    };

    if (isLoading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress />
        </Box>
      );
    }

    if (error) {
      return (
        <Card>
          <CardContent>
            <Typography color="error">{error}</Typography>
          </CardContent>
        </Card>
      );
    }

    return (
      <Card>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <DescriptionIcon color="primary" sx={{ mr: 1 }} />
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              Account Statement
            </Typography>
          </Box>

          {statementData.length > 0 ? (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>Month</TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>Std Rent</TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>Coupan Disc</TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>Net Rent</TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>Fm Disc</TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>Eff Rent</TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>1st Installment</TableCell>
                    <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>Due Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {statementData.map((item) => {
                    const status = getPaymentStatus(item);
                    return (
                      <TableRow key={`${item.MonthId}-${item.YearNm}`}>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{item.MonthNm.slice(0, 3)} {item.YearNm.toString().slice(-2)}</TableCell>
                        <TableCell align="right" sx={{ p: 0.5 }}>{formatCurrency(item.StdRent)}</TableCell>
                        <TableCell align="right">{formatCurrency(item.CouponDisc)}</TableCell>
                        <TableCell align="right">{formatCurrency(item.NetRent)}</TableCell>
                        <TableCell align="right">{formatCurrency(item.FmDisc)}</TableCell>
                        <TableCell align="right" sx={{ p: 0.5 }}>{formatCurrency(item.EffRent)}</TableCell>
                        <TableCell align="right">{formatCurrency(item.PyadAmt)}</TableCell>
                        <TableCell align="right">{item.PyadDt ? formatDate(item.PyadDt) : '-'}</TableCell>
                      </TableRow>
                    );
                  })}
                  <TableRow sx={{ backgroundColor: theme.palette.grey[100] }}>
                    <TableCell><strong>Total</strong></TableCell>
                    <TableCell align="right"><strong>{formatCurrency(totalSummary.totalStdRent)}</strong></TableCell>
                    <TableCell align="right"><strong>{formatCurrency(totalSummary.totalCouponDisc)}</strong></TableCell>
                    <TableCell align="right"><strong>{formatCurrency(totalSummary.totalNetRent)}</strong></TableCell>
                    <TableCell align="right"><strong>{formatCurrency(totalSummary.totalFmDisc)}</strong></TableCell>
                    <TableCell align="right"><strong>{formatCurrency(totalSummary.totalEffRent)}</strong></TableCell>
                    <TableCell align="right"><strong>{formatCurrency(totalSummary.totalPyadAmt)}</strong></TableCell>
                    <TableCell colSpan={2}></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
              No statement data available
            </Typography>
          )}
        </CardContent>
      </Card>
    );
  };

  const totalAmount = adviceData.reduce((sum, item) => sum + (item.MonthlyNetAmt || item.Amount || 0), 0);
  const totalPaid = adviceData.reduce((sum, item) => sum + (item.RcdAmt || 0), 0);
  const totalDue = totalAmount - totalPaid;
  const fetchPlanDataState = async (PlanId) => {
    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
        "RoomPlanID": PlanId,
        "Flag": "R"
      });

      if (response.data.Status === 0) {
        setPlanDataState(response.data.Data);
        setOpenBillingModal(true);
      } else {
        console.error('Error fetching Grid data:', response.data.Message);

      }
    } catch (error) {
      console.error('Error fetching plan data:', error);
    } finally {
      setOpenLoader(false);
    }
  };

  const fetchPayAdvice = async (BookId) => {
    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        "PytAdvDt": "2025-03-07",
        "Flag": "BookingWise",
        "BookId": BookId
      });

      if (response.data.Status === 0) {
        setPayAdvice(response.data.Data);
        setOpenBillingModal(true);
      } else {
        console.error('Error fetching Grid data:', response.data.Message);
      }
    } catch (error) {
      console.error('Error fetching plan data:', error);
    } finally {
      setOpenLoader(false);
    }
  };

  const fetchPayGenerate = async (Id) => {
    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        "PytAdvDt": "2025-02-26",
        "Flag": "GenPytAdv",
        "BookId": Id
      });

      if (response.data.Status === 0) {
        setPayGenerate(response.data.Data);
        setOpenBillingModal(true);
      }
    } catch (error) {
      console.error('Error fetching pay generate data:', error);
    } finally {
      setOpenLoader(false);
    }
  };

  const fetchPendingDetails = async (pendingId) => {
    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        "Flag": "UnBilledAdvPyt",
        "BookId": pendingId,
        "PytAdvDt": "2025-05-20"
      });

      if (response.data.Status === 0) {
        setPendingDetails(response.data.Data);
        setOpenBillingModal(true);
      } else {
        console.info(response.data.Message);
      }
    } catch (error) {
      console.error('Error fetching pending details data:', error);
    } finally {
      setOpenLoader(false);
    }
  };
  const handleBillingDetails = async () => {
const currentBookId = selectedBookId || bookingData.BookId;
    if (currentBookId === -1 || !currentBookId) {
      toast.info("No transaction is visible");
      return;
    }

    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(
        'TrnBooking/GetReportTrnBooking',
        {
          "BookId": currentBookId,
          "Flag": "R"
        }
      );
      if (response.data.Status === 0 && response.data.Data) {
        setBillingDetails(response.data.Data);
        setOpenBillingModal(true);

        await fetchPlanDataState(response.data.Data.TrnBookingList[0].RoomPlanId);
        await fetchPayAdvice(currentBookId);
        await fetchPayGenerate(currentBookId);
        await fetchPendingDetails(currentBookId);
        await fetchReceiptReport(currentBookId)
        await fetchSummaryReport(currentBookId)
        setOpenBillingModal(true);
      } else {
        toast.error('No billing details found');
      }
    } catch (error) {
      console.error('Error fetching billing details:', error);
      toast.error('Error fetching billing details');
    } finally {
      setOpenLoader(false);
    }
  };
  const handleCloseBillingModal = () => {
    setOpenBillingModal(false);
    setActiveView('advice');
  };

  const toggleButtonStyle = {
    borderRadius: 2,
    px: 2,
    py: 1,
    textTransform: 'none',
    fontWeight: 'medium',
    color: 'text.primary',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    transition: 'all 0.2s ease-in-out',
    '&.Mui-selected': {
      bgcolor: 'primary.main',
      color: '#fff',
      '&:hover': {
        bgcolor: 'primary.dark',
      },
    },
    '&:hover': {
      bgcolor: 'grey.100',
    },
  };

  const iconStyle = {
    fontSize: '1.25rem',
  };

  return (
    <Box sx={{ mt: 2 }}>
      <ToastContainer />
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
        <ToggleButtonGroup
          value={activeView}
          exclusive
          onChange={(e, newView) => handleViewChange(newView)}
          aria-label="view toggle"
          size={isMobile ? 'small' : 'medium'}
          sx={{
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 1,
            p: 0.5,
            gap: 1,
          }}
        >
          <ToggleButton
            value="statement"
            aria-label="statement"
            sx={toggleButtonStyle}
          >
            <DescriptionIcon sx={iconStyle} />
            {!isMobile && <Typography sx={{ fontWeight: 500 }}>Statement</Typography>}
          </ToggleButton>

          <ToggleButton
            value="advice"
            aria-label="payment advice"
            sx={toggleButtonStyle}
          >
            <ReceiptIcon sx={iconStyle} />
            {!isMobile && <Typography sx={{ fontWeight: 500 }}>Payment Advice</Typography>}
          </ToggleButton>

          <ToggleButton
            value="payment"
            aria-label="make payment"
            sx={toggleButtonStyle}
          >
            <PaymentIcon sx={iconStyle} />
            {!isMobile && <Typography sx={{ fontWeight: 500 }}>Payment</Typography>}
          </ToggleButton>

          <ToggleButton
            value="booking-details"
            aria-label="booking details"
            sx={toggleButtonStyle}
          >
            <CalendarViewMonthIcon sx={iconStyle} />
            {!isMobile && <Typography sx={{ fontWeight: 500 }}>Booking Details</Typography>}
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {isLoading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {activeView === 'statement' && (
            <BillingDetailsModal
              open={openBillingModal}
              onClose={handleCloseBillingModal}
              billingData={billingDetails}
              planData={PlanDataState}
              payAdvice={PayAdvice}
              payGenerate={PayGenerate}
              pendingDetails={PendingDetails}
              summaryReport={SummaryReport} receiptSummary={ReceiptSummary}
            />
          )}
          {activeView === 'advice' && <InstallmentPlanView />}
          {activeView === 'booking-details' && <BookingDetail />}
          {activeView === 'payment' && <PaymentView />}
        </>
      )}

      {adviceData.length > 0 && activeView === 'advice' && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          {/* Total Amount */}
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                background: '#e3f2fd',
                borderRadius: 2,
                boxShadow: 3,
                transition: 'transform 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <CardContent sx={{ textAlign: 'center', p: '16px !important' }}>
                <CurrencyRupeeIcon sx={{ fontSize: 40, color: '#1976d2' }} />
                <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Total Amount
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  {formatCurrency(totalAmount)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Total Paid */}
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                background: '#e8f5e9',
                borderRadius: 2,
                boxShadow: 3,
                transition: 'transform 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <CardContent sx={{ textAlign: 'center', p: '16px !important' }}>
                <CurrencyRupeeIcon sx={{ fontSize: 40, color: '#2e7d32' }} />
                <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Total Paid
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  {formatCurrency(totalPaid)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Balance Due */}
          <Grid item xs={12} sm={4}>
            <Card
              sx={{
                background: '#fff8e1',
                borderRadius: 2,
                boxShadow: 3,
                transition: 'transform 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <CardContent sx={{ textAlign: 'center', p: '16px !important' }}>
                <PendingActionsIcon sx={{ fontSize: 40, color: '#f9a825' }} />
                <Typography variant="subtitle2" color="text.secondary" sx={{ fontWeight: 600 }}>
                  Balance Due
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  {formatCurrency(totalDue)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default AccountsTab;